module.exports = __webpack_public_path__ + "expedia-fav-icon.png?63c5a959e4f881dc2fea1ad480f0c5d1";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/expedia-fav-icon.png
// module id = 490
// module chunks = 0